webpackJsonp([25],{

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/front/lib/api.js

// export const CORE_API_ENDPOINT = `https://frontweb.rmbainisys.com/depa`

// export const CORE_API_ENDPOINT = `http://10.0.30.9:8801/api`
// 
// export const CORE_API_ENDPOINT = `/depa`

// export const CORE_API_ENDPOINT = `/api/core`

// export const CORE_API_ENDPOINT = `http://localhost:2000`

//.9 new 2020
var CORE_API_ENDPOINT = "/api";
var SLOT_DURATION = 1;
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(514);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__(515);
var jsonwebtoken_default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken);

// CONCATENATED MODULE: ./src/front/lib/auth.js



var BSRS_ACCESS_TOKEN = 'bsrs_access_token';
var ACCESS_TOKEN = 'access_token';
var BACKUP_ACCESS_TOKEN = 'backup_access_token';
var EXPIRES_ON = 'expires_on';
var USER_EMAIL = 'user_email';
var USER_ID = 'user_id';
var IS_AGREE = 'isAgreeTermAndCondition';
var FULL_NAME = 'fullName';
var EMP_ID = 'employeeId';
var ROLE = 'role';
var IS_EXECUTIVE = 'isExecutive';
var AMENITY = 'AmenityPage';
var IS_ACTIVE = 'isActive';
var AMENITYSERVICE_FLOOR = 'AMENITYSERVICE_FLOOR';
var ONBEHALFOF = 'onBehalfOf';

function getCookie(key) {
    return js_cookie_default.a.get(key);
}

function setCookie(key, value) {
    js_cookie_default.a.set(key, value);
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function getAccessToken() {
    return getCookie(ACCESS_TOKEN);
}
function getBackupAccessToken() {
    return getCookie(BACKUP_ACCESS_TOKEN);
}
function getIsActive() {
    return getCookie(IS_ACTIVE) === 'true';
}

function getRole() {
    return getCookie(ROLE);
}

function getIsExecutive() {
    return getCookie(IS_EXECUTIVE) === 'true';
}

function getAllToken() {

    if (!getCookie(ACCESS_TOKEN)) return {};
    return {
        access_token: getCookie(ACCESS_TOKEN),
        user_email: getCookie(USER_EMAIL),
        user_id: getCookie(USER_ID),
        expired_on: getCookie(EXPIRES_ON),
        isAgreeTermAndCondition: getCookie(IS_AGREE),
        fullName: getCookie(FULL_NAME),
        employeeId: getCookie(EMP_ID),
        role: getCookie(ROLE),
        isExecutive: getCookie(ONBEHALFOF)
    };
}

function getAmenityToken() {
    return {
        amenity: getCookie(AMENITY)
    };
}

function setToken(props) {
    clearBSRSToken();
    var token = props.token,
        email = props.email,
        userId = props.userId,
        expires_date_on = props.expires_date_on,
        isAgreeTermAndCondition = props.isAgreeTermAndCondition,
        employeeId = props.employeeId,
        fullName = props.fullName,
        role = props.role,
        isExecutive = props.isExecutive,
        isActive = props.isActive,
        isBehalfOf = props.isBehalfOf;

    if (typeof token !== "undefined") setCookie(ACCESS_TOKEN, token);
    if (typeof token !== "undefined") setCookie(BACKUP_ACCESS_TOKEN, token);
    if (typeof email !== "undefined") setCookie(USER_EMAIL, email);
    if (typeof userId !== "undefined") setCookie(USER_ID, userId);
    if (typeof expires_date_on !== "undefined") setCookie(EXPIRES_ON, expires_date_on);
    if (typeof isAgreeTermAndCondition !== "undefined") setCookie(IS_AGREE, isAgreeTermAndCondition);
    if (typeof fullName !== "undefined") setCookie(FULL_NAME, fullName);
    if (typeof employeeId !== "undefined") setCookie(EMP_ID, employeeId);
    if (typeof role !== "undefined") setCookie(ROLE, role);
    if (typeof isExecutive !== "undefined") setCookie(IS_EXECUTIVE, isExecutive);
    if (typeof isBehalfOf !== "undefined") setCookie(ONBEHALFOF, isBehalfOf);
    setCookie(IS_ACTIVE, isActive);
}

function clearToken() {
    removeCookie(ACCESS_TOKEN);
    removeCookie(USER_EMAIL);
    removeCookie(USER_ID);
    removeCookie(IS_AGREE);
    removeCookie(FULL_NAME);
    removeCookie(EMP_ID);
    removeCookie(ROLE);
    removeCookie(IS_EXECUTIVE);
    removeCookie(IS_ACTIVE);
    removeCookie(ONBEHALFOF);
}

function getUserInfo(access_token) {
    if (!access_token) return {};

    var _jwt$decode = jsonwebtoken_default.a.decode(access_token),
        iat = _jwt$decode.iat,
        exp = _jwt$decode.exp,
        appid = _jwt$decode.appid,
        name = _jwt$decode.name,
        email = _jwt$decode.unique_name;

    return {
        iat: iat,
        exp: exp,
        appid: appid,
        name: name,
        email: email
    };
}
function setIsAgree() {
    return setCookie(IS_AGREE, true);
}
function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN);
}

function getfullName() {
    return getCookie(FULL_NAME);
}

function getUserId() {
    return getCookie(USER_ID);
}

function setBSRSToken(access_token) {
    setCookie(BSRS_ACCESS_TOKEN, access_token);
}

function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN);
    removeCookie(ACCESS_TOKEN);
    removeCookie(USER_EMAIL);
    removeCookie(USER_ID);
    removeCookie(EXPIRES_ON);
    removeCookie(IS_AGREE);
    removeCookie(FULL_NAME);
    removeCookie(EMP_ID);
    removeCookie(ROLE);
    removeCookie(IS_ACTIVE);
    removeCookie(BACKUP_ACCESS_TOKEN);
    removeCookie(ONBEHALFOF);
}

function setAmenityserviceFloor(value) {
    removeCookie(AMENITYSERVICE_FLOOR);
    setCookie(AMENITYSERVICE_FLOOR, value);
}

function getAmenityserviceFloor() {
    return getCookie(AMENITYSERVICE_FLOOR);
}
// CONCATENATED MODULE: ./src/front/lib/setting.js
var timeZone = 'Asia/Bangkok';
var dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
var LongDateTimeFormat = 'ddd MMM D, YYYY HH:mm';
var ShortDateTimeFormat = 'D MMM YYYY HH:mm';
var LongDateFormat = 'ddd, DD MMM YYYY';
var ShortDateFormat = 'D MMM YYYY';
var timeFormat = 'HH:mm';
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(23);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var react_router_dom_es = __webpack_require__(104);

// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(80);

// EXTERNAL MODULE: ./src/front/features/user/selectors.js
var selectors = __webpack_require__(476);

// CONCATENATED MODULE: ./src/front/lib/withAuthCheck.js






var withAuthCheck_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/login' });
};
var withAuthCheck_withAuthCheck = function withAuthCheck(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheck = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheck'), Object(es["connect"])(function (state) {
    return {
      isLoggedIn: Object(selectors["b" /* getIsLoggedIn */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn;
  }, withAuthCheck_withAuthCheck, Object(Recompose["d" /* renderComponent */])(withAuthCheck_RedirectToLogin)))(WrappedComponent);
});
// EXTERNAL MODULE: ./src/front/features/auth/selectors.js
var auth_selectors = __webpack_require__(221);

// CONCATENATED MODULE: ./src/front/lib/withAuthCheckO365.js






var withAuthCheckO365_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/logino365' });
};
var withAuthCheckO365_withAuthCheckO365 = function withAuthCheckO365(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheckO365 = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheckO365'), Object(es["connect"])(function (state) {
    return {
      isLoggedInO365: Object(auth_selectors["b" /* getIsLoggedInO365 */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedInO365 = _ref.isLoggedInO365;
    return isLoggedInO365;
  }, withAuthCheckO365_withAuthCheckO365, Object(Recompose["d" /* renderComponent */])(withAuthCheckO365_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/front/lib/withO365UserInfo.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var withO365UserInfo_withO365UserInfo = function withO365UserInfo(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, _extends({}, props, { O365UserInfo: props.userInfo }));
  };
};

/* harmony default export */ var lib_withO365UserInfo = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withO365UserInfo'), Object(es["connect"])(function (state) {
    return {
      userInfo: Object(auth_selectors["c" /* getUserInfo */])(state)
    };
  }), withO365UserInfo_withO365UserInfo)(WrappedComponent);
});
// CONCATENATED MODULE: ./src/front/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return SLOT_DURATION; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return getAccessToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return getBackupAccessToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getIsActive; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return getRole; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getIsExecutive; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return getAllToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getAmenityToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return setToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return clearToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return setIsAgree; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return getfullName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return getUserId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return setBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return clearBSRSToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setAmenityserviceFloor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return getAmenityserviceFloor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return timeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return dateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return LongDateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return ShortDateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return LongDateFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return ShortDateFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return timeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return lib_withAuthCheck; });
/* unused concated harmony import withAuthCheckO365 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheckO365; });
/* unused concated harmony import withO365UserInfo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withO365UserInfo; });







/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getIsLoading;
/* harmony export (immutable) */ __webpack_exports__["b"] = getHasError;
/* unused harmony export getErrorMessage */
/* unused harmony export getErrorCode */
/* harmony export (immutable) */ __webpack_exports__["d"] = getUiMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = getError;
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getErrorMessage(state) {
    return state.ui.errorMessage;
}

function getErrorCode(state) {
    return state.ui.errorCode;
}

function getUiMessage(state) {
    return state.ui;
}

function getError(state) {
    return state.ui.error;
}

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLoggedInO365;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUserInfo;
/* unused harmony export getUserEmail */
function getIsLoggedIn(state) {
    return !!state.auth.bsrsToken;
}

function getIsLoggedInO365(state) {
    return !!state.auth.token.access_token;
}

function getUserInfo(state) {
    return state.auth.user;
}

function getUserEmail(state) {
    return state.auth.user.email;
}

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BSRS_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BSRS_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSRS_LOGIN_FAILURE; });
/* unused harmony export CORE_LOAD_ORDER_DETAIL_REQUEST */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_SUCCESS */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_FAILURE */
/* unused harmony export CORE_CHANGE_ORDER_AMOUNT */
/* unused harmony export CORE_UPSERT_ORDERS_REQUEST */
/* unused harmony export CORE_UPSERT_ORDERS_SUCCESS */
/* unused harmony export CORE_UPSERT_ORDERS_FAILURE */
/* unused harmony export CORE_LOAD_CHEKIN_REQUEST */
/* unused harmony export CORE_LOAD_CHEKIN_SUCCESS */
/* unused harmony export CORE_LOAD_CHEKIN_FAILURE */
/* unused harmony export CORE_CREATE_CHECKIN_REQUEST */
/* unused harmony export CORE_CREATE_CHECKIN_SUCCESS */
/* unused harmony export CORE_CREATE_CHECKIN_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_SEARCH_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_SEARCH_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_SEARCH_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_ROOMS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_LOAD_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_LOAD_ROOMS_SUGGEST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_LOAD_ROOMS_SUGGEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_LOAD_ROOMS_SUGGEST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_LOAD_SLOTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_LOAD_SLOTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_LOAD_SLOTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_LOAD_FLOORS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_LOAD_FLOORS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_LOAD_FLOORS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_LOAD_FLOOR_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_LOAD_FLOOR_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_LOAD_FLOOR_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_LOAD_AMENITIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_LOAD_AMENITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_LOAD_AMENITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_LOAD_ROOMINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_LOAD_ROOMINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_LOAD_ROOMINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return LOAD_ROOMINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return LOAD_ROOMINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return LOAD_ROOMINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CREATE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CREATE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CREATE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_EDIT_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_EDIT_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_EDIT_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_DELETE_EVENT_RECURRENCE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_DELETE_EVENT_RECURRENCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_DELETE_EVENT_RECURRENCE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_LOAD_EVENTINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_LOAD_EVENTINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_LOAD_EVENTINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_LOAD_EVENTINCOMING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_LOAD_EVENTINCOMING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_LOAD_EVENTINCOMING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_LOAD_EVENTHISTORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_LOAD_EVENTHISTORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_LOAD_EVENTHISTORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_VERIFY_BYPASS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_VERIFY_BYPASS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_VERIFY_BYPASS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_ACCEPT_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_ACCEPT_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_ACCEPT_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CHECKIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CHECKIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CHECKIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_LOAD_EVENTCALENDAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_LOAD_EVENTCALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_LOAD_EVENTCALENDAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_LOAD_AMENITYACTIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_LOAD_AMENITYACTIVE_SUCCESS; });
/* unused harmony export CORE_LOAD_AMENITYACTIVE_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_LOAD_ORDERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_LOAD_ORDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_LOAD_ORDERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_LOAD_AMENITYPAST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_LOAD_AMENITYPAST_SUCCESS; });
/* unused harmony export CORE_LOAD_AMENITYPAST_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_LOAD_AMENITYNEXT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_LOAD_AMENITYNEXT_SUCCESS; });
/* unused harmony export CORE_LOAD_AMENITYNEXT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_LOAD_FOODS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_LOAD_FOODS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_LOAD_FOODS_FAILURE; });
/* unused harmony export CORE_LOAD_SERVICEACTIVE_REQUEST */
/* unused harmony export CORE_LOAD_SERVICEACTIVE_SUCCESS */
/* unused harmony export CORE_LOAD_SERVICEACTIVE_FAILURE */
/* unused harmony export CORE_LOAD_SERVICEPAST_REQUEST */
/* unused harmony export CORE_LOAD_SERVICEPAST_SUCCESS */
/* unused harmony export CORE_LOAD_SERVICEPAST_FAILURE */
/* unused harmony export CORE_DELETE_ORDER_REQUEST */
/* unused harmony export CORE_DELETE_ORDER_SUCCESS */
/* unused harmony export CORE_DELETE_ORDER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_SENDAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_SENDAMENITY_SUCCESS; });
/* unused harmony export CORE_SENDAMENITY_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_SENDFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_SENDFOOD_SUCCESS; });
/* unused harmony export CORE_SENDFOOD_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_LOAD_FOODACTIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_LOAD_FOODACTIVE_SUCCESS; });
/* unused harmony export CORE_LOAD_FOODACTIVE_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_LOAD_FOODPAST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_LOAD_FOODPAST_SUCCESS; });
/* unused harmony export CORE_LOAD_FOODPAST_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_LOAD_FOODNEXT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_LOAD_FOODNEXT_SUCCESS; });
/* unused harmony export CORE_LOAD_FOODNEXT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_DONEAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_DONEAMENITY_SUCCESS; });
/* unused harmony export CORE_DONEAMENITY_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_DONEFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_DONEFOOD_SUCCESS; });
/* unused harmony export CORE_DONEFOOD_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CANCELEVENTAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CANCELEVENTAMENITY_SUCCESS; });
/* unused harmony export CORE_CANCELEVENTAMENITY_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CANCELEVENTFOOD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CANCELEVENTFOOD_SUCCESS; });
/* unused harmony export CORE_CANCELEVENTFOOD_FAILURE */
/* unused harmony export CORE_CREATE_ORDER_REQUEST */
/* unused harmony export CORE_CREATE_ORDER_SUCCESS */
/* unused harmony export CORE_CREATE_ORDER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_LOAD_ORDER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_LOAD_ORDER_INFO_SUCCESS; });
/* unused harmony export CORE_LOAD_ORDER_INFO_FAILURE */
/* unused harmony export CORE_EDIT_ORDER_REQUEST */
/* unused harmony export CORE_EDIT_ORDER_SUCCESS */
/* unused harmony export CORE_EDIT_ORDER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_LOAD_LAST_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_LOAD_LAST_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_LOAD_LAST_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_LOAD_EVENT_LOG_TITLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_LOAD_EVENT_LOG_TITLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_LOAD_EVENT_LOG_TITLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CREATE_EVENT_LOG_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CREATE_EVENT_LOG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CREATE_EVENT_LOG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_SCANQR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_SCANQR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_SCANQR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_LOAD_ROOM_FORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_LOAD_ROOM_FORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_LOAD_ROOM_FORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_LOAD_EVENTSERVICEAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS; });
/* unused harmony export CORE_LOAD_EVENTSERVICEAMENITY_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_LOAD_EVENTSERVICEFBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_LOAD_EVENTSERVICEFBS_SUCCESS; });
/* unused harmony export CORE_LOAD_EVENTSERVICEFBS_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_LOAD_ROOM_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_LOAD_ROOM_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_LOAD_ROOM_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_LOAD_EVENTINFOSERVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_LOAD_EVENTINFOSERVICE_SUCCESS; });
/* unused harmony export CORE_LOAD_EVENTINFOSERVICE_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_SAVE_FORMSUGGEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_SAVE_FORMSEARCHNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CLEAR_FORMSEARCHNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_LOAD_SETTINGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_LOAD_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_LOAD_SETTINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_VERIFY_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_VERIFY_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_VERIFY_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_SEND_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_SEND_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_SEND_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_FIRST_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_FIRST_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_FIRST_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_LOAD_LOCATION_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_LOAD_LOCATION_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_LOAD_LOCATION_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CHANGEROLE_FRONTEND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CHANGEROLE_FRONTEND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CHANGEROLE_FRONTEND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_LOAD_ROLESETTINGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_LOAD_ROLESETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_LOAD_ROLESETTINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_LOAD_ALL_EVENT_ROOM_SERVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CHANGEEMAILNOTI_FRONTEND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_FAILURE; });
var LOGOUT = 'LOGOUT';
var SET_ERROR = 'SET_ERROR';

var BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST';
var BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS';
var BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE';

var CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST';
var CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS';
var CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE';

var CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT';

var CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST';
var CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS';
var CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE';

var CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST';
var CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS';
var CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE';

var CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST';
var CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS';
var CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE';

var CORE_SEARCH_ROOMS_REQUEST = 'CORE_SEARCH_ROOMS_REQUEST';
var CORE_SEARCH_ROOMS_SUCCESS = 'CORE_SEARCH_ROOMS_SUCCESS';
var CORE_SEARCH_ROOMS_FAILURE = 'CORE_SEARCH_ROOMS_FAILURE';
var CORE_ROOMS_CLEAR = 'CORE_ROOMS_CLEAR';

var CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST';
var CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS';
var CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE';

var CORE_LOAD_ROOMS_SUGGEST_REQUEST = 'CORE_LOAD_ROOMS_SUGGEST_REQUEST';
var CORE_LOAD_ROOMS_SUGGEST_SUCCESS = 'CORE_LOAD_ROOMS_SUGGEST_SUCCESS';
var CORE_LOAD_ROOMS_SUGGEST_FAILURE = 'CORE_LOAD_ROOMS_SUGGEST_FAILURE';

var CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST';
var CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS';
var CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE';

var CORE_LOAD_SLOTS_REQUEST = 'CORE_LOAD_SLOTS_REQUEST';
var CORE_LOAD_SLOTS_SUCCESS = 'CORE_LOAD_SLOTS_SUCCESS';
var CORE_LOAD_SLOTS_FAILURE = 'CORE_LOAD_SLOTS_FAILURE';

var CORE_LOAD_FLOORS_REQUEST = 'CORE_LOAD_FLOORS_REQUEST';
var CORE_LOAD_FLOORS_SUCCESS = 'CORE_LOAD_FLOORS_SUCCESS';
var CORE_LOAD_FLOORS_FAILURE = 'CORE_LOAD_FLOORS_FAILURE';

var CORE_LOAD_FLOOR_INFO_REQUEST = 'CORE_LOAD_FLOOR_INFO_REQUEST';
var CORE_LOAD_FLOOR_INFO_SUCCESS = 'CORE_LOAD_FLOOR_INFO_SUCCESS';
var CORE_LOAD_FLOOR_INFO_FAILURE = 'CORE_LOAD_FLOOR_INFO_FAILURE';

var CORE_LOAD_AMENITIES_REQUEST = 'CORE_LOAD_AMENITIES_REQUEST';
var CORE_LOAD_AMENITIES_SUCCESS = 'CORE_LOAD_AMENITIES_SUCCESS';
var CORE_LOAD_AMENITIES_FAILURE = 'CORE_LOAD_AMENITIES_FAILURE';

var CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST';
var CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS';
var CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE';

var CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST';
var CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS';
var CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE';

var CORE_LOAD_ROOMINFO_REQUEST = 'CORE_LOAD_ROOMINFO_REQUEST';
var CORE_LOAD_ROOMINFO_SUCCESS = 'CORE_LOAD_ROOMINFO_SUCCESS';
var CORE_LOAD_ROOMINFO_FAILURE = 'CORE_LOAD_ROOMINFO_FAILURE';

var LOAD_ROOMINFO_REQUEST = 'LOAD_ROOMINFO_REQUEST';
var LOAD_ROOMINFO_SUCCESS = 'LOAD_ROOMINFO_SUCCESS';
var LOAD_ROOMINFO_FAILURE = 'LOAD_ROOMINFO_FAILURE';

var CORE_CREATE_EVENT_REQUEST = 'CORE_CREATE_EVENT_REQUEST';
var CORE_CREATE_EVENT_SUCCESS = 'CORE_CREATE_EVENT_SUCCESS';
var CORE_CREATE_EVENT_FAILURE = 'CORE_CREATE_EVENT_FAILURE';

var CORE_EDIT_EVENT_REQUEST = 'CORE_EDIT_EVENT_REQUEST';
var CORE_EDIT_EVENT_SUCCESS = 'CORE_EDIT_EVENT_SUCCESS';
var CORE_EDIT_EVENT_FAILURE = 'CORE_EDIT_EVENT_FAILURE';

var CORE_DELETE_EVENT_REQUEST = 'CORE_DELETE_EVENT_REQUEST';
var CORE_DELETE_EVENT_SUCCESS = 'CORE_DELETE_EVENT_SUCCESS';
var CORE_DELETE_EVENT_FAILURE = 'CORE_DELETE_EVENT_FAILURE';

var CORE_DELETE_EVENT_RECURRENCE_REQUEST = 'CORE_DELETE_EVENT_RECURRENCE_REQUEST';
var CORE_DELETE_EVENT_RECURRENCE_SUCCESS = 'CORE_DELETE_EVENT_RECURRENCE_SUCCESS';
var CORE_DELETE_EVENT_RECURRENCE_FAILURE = 'CORE_DELETE_EVENT_RECURRENCE_FAILURE';

var CORE_LOAD_EVENTINFO_REQUEST = 'CORE_LOAD_EVENTINFO_REQUEST';
var CORE_LOAD_EVENTINFO_SUCCESS = 'CORE_LOAD_EVENTINFO_SUCCESS';
var CORE_LOAD_EVENTINFO_FAILURE = 'CORE_LOAD_EVENTINFO_FAILURE';

var CORE_LOAD_EVENTINCOMING_REQUEST = 'CORE_LOAD_EVENTINCOMING_REQUEST';
var CORE_LOAD_EVENTINCOMING_SUCCESS = 'CORE_LOAD_EVENTINCOMING_SUCCESS';
var CORE_LOAD_EVENTINCOMING_FAILURE = 'CORE_LOAD_EVENTINCOMING_FAILURE';

var CORE_LOAD_EVENTHISTORY_REQUEST = 'CORE_LOAD_EVENTHISTORY_REQUEST';
var CORE_LOAD_EVENTHISTORY_SUCCESS = 'CORE_LOAD_EVENTHISTORY_SUCCESS';
var CORE_LOAD_EVENTHISTORY_FAILURE = 'CORE_LOAD_EVENTHISTORY_FAILURE';

var CORE_VERIFY_BYPASS_REQUEST = 'CORE_VERIFY_BYPASS_REQUEST';
var CORE_VERIFY_BYPASS_SUCCESS = 'CORE_VERIFY_BYPASS_SUCCESS';
var CORE_VERIFY_BYPASS_FAILURE = 'CORE_VERIFY_BYPASS_FAILURE';

var CORE_ACCEPT_TERM_REQUEST = 'CORE_ACCEPT_TERM_REQUEST';
var CORE_ACCEPT_TERM_SUCCESS = 'CORE_ACCEPT_TERM_SUCCESS';
var CORE_ACCEPT_TERM_FAILURE = 'CORE_ACCEPT_TERM_FAILURE';

var CORE_CHECKIN_REQUEST = 'CORE_CHECKIN_REQUEST';
var CORE_CHECKIN_SUCCESS = 'CORE_CHECKIN_SUCCESS';
var CORE_CHECKIN_FAILURE = 'CORE_CHECKIN_FAILURE';

var CORE_LOAD_EVENTCALENDAR_REQUEST = 'CORE_LOAD_EVENTCALENDAR_REQUEST';
var CORE_LOAD_EVENTCALENDAR_SUCCESS = 'CORE_LOAD_EVENTCALENDAR_SUCCESS';
var CORE_LOAD_EVENTCALENDAR_FAILURE = 'CORE_LOAD_EVENTCALENDAR_FAILURE';

var CORE_LOAD_AMENITYACTIVE_REQUEST = 'CORE_LOAD_AMENITYACTIVE_REQUEST';
var CORE_LOAD_AMENITYACTIVE_SUCCESS = 'CORE_LOAD_AMENITYACTIVE_SUCCESS';
var CORE_LOAD_AMENITYACTIVE_FAILURE = 'CORE_LOAD_AMENITYACTIVE_FAILURE';

var CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST';
var CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS';
var CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE';

var CORE_LOAD_AMENITYPAST_REQUEST = 'CORE_LOAD_AMENITYPAST_REQUEST';
var CORE_LOAD_AMENITYPAST_SUCCESS = 'CORE_LOAD_AMENITYPAST_SUCCESS';
var CORE_LOAD_AMENITYPAST_FAILURE = 'CORE_LOAD_AMENITYPAST_FAILURE';

var CORE_LOAD_AMENITYNEXT_REQUEST = 'CORE_LOAD_AMENITYNEXT_REQUEST';
var CORE_LOAD_AMENITYNEXT_SUCCESS = 'CORE_LOAD_AMENITYNEXT_SUCCESS';
var CORE_LOAD_AMENITYNEXT_FAILURE = 'CORE_LOAD_AMENITYNEXT_FAILURE';

var CORE_LOAD_FOODS_REQUEST = 'CORE_LOAD_FOODS_REQUEST';
var CORE_LOAD_FOODS_SUCCESS = 'CORE_LOAD_FOODS_SUCCESS';
var CORE_LOAD_FOODS_FAILURE = 'CORE_LOAD_FOODS_FAILURE';

var CORE_LOAD_SERVICEACTIVE_REQUEST = 'CORE_LOAD_SERVICEACTIVE_REQUEST';
var CORE_LOAD_SERVICEACTIVE_SUCCESS = 'CORE_LOAD_SERVICEACTIVE_SUCCESS';
var CORE_LOAD_SERVICEACTIVE_FAILURE = 'CORE_LOAD_SERVICEACTIVE_FAILURE';

var CORE_LOAD_SERVICEPAST_REQUEST = 'CORE_LOAD_SERVICEPAST_REQUEST';
var CORE_LOAD_SERVICEPAST_SUCCESS = 'CORE_LOAD_SERVICEPAST_SUCCESS';
var CORE_LOAD_SERVICEPAST_FAILURE = 'CORE_LOAD_SERVICEPAST_FAILURE';

var CORE_DELETE_ORDER_REQUEST = 'CORE_DELETE_ORDER_REQUEST';
var CORE_DELETE_ORDER_SUCCESS = 'CORE_DELETE_ORDER_SUCCESS';
var CORE_DELETE_ORDER_FAILURE = 'CORE_DELETE_ORDER_FAILURE';

var CORE_SENDAMENITY_REQUEST = 'CORE_SENDAMENITY_REQUEST';
var CORE_SENDAMENITY_SUCCESS = 'CORE_SENDAMENITY_SUCCESS';
var CORE_SENDAMENITY_FAILURE = 'CORE_SENDAMENITY_FAILURE';

var CORE_SENDFOOD_REQUEST = 'CORE_SENDFOOD_REQUEST';
var CORE_SENDFOOD_SUCCESS = 'CORE_SENDFOOD_SUCCESS';
var CORE_SENDFOOD_FAILURE = 'CORE_SENDFOOD_FAILURE';

var CORE_LOAD_FOODACTIVE_REQUEST = 'CORE_LOAD_FOODACTIVE_REQUEST';
var CORE_LOAD_FOODACTIVE_SUCCESS = 'CORE_LOAD_FOODACTIVE_SUCCESS';
var CORE_LOAD_FOODACTIVE_FAILURE = 'CORE_LOAD_FOODACTIVE_FAILURE';

var CORE_LOAD_FOODPAST_REQUEST = 'CORE_LOAD_FOODPAST_REQUEST';
var CORE_LOAD_FOODPAST_SUCCESS = 'CORE_LOAD_FOODPAST_SUCCESS';
var CORE_LOAD_FOODPAST_FAILURE = 'CORE_LOAD_FOODPAST_FAILURE';

var CORE_LOAD_FOODNEXT_REQUEST = 'CORE_LOAD_FOODNEXT_REQUEST';
var CORE_LOAD_FOODNEXT_SUCCESS = 'CORE_LOAD_FOODNEXT_SUCCESS';
var CORE_LOAD_FOODNEXT_FAILURE = 'CORE_LOAD_FOODNEXT_FAILURE';

var CORE_DONEAMENITY_REQUEST = 'CORE_DONEAMENITY_REQUEST';
var CORE_DONEAMENITY_SUCCESS = 'CORE_DONEAMENITY_SUCCESS';
var CORE_DONEAMENITY_FAILURE = 'CORE_DONEAMENITY_FAILURE';

var CORE_DONEFOOD_REQUEST = 'CORE_DONEFOOD_REQUEST';
var CORE_DONEFOOD_SUCCESS = 'CORE_DONEFOOD_SUCCESS';
var CORE_DONEFOOD_FAILURE = 'CORE_DONEFOOD_FAILURE';

var CORE_CANCELEVENTAMENITY_REQUEST = 'CORE_CANCELEVENTAMENITY_REQUEST';
var CORE_CANCELEVENTAMENITY_SUCCESS = 'CORE_CANCELEVENTAMENITY_SUCCESS';
var CORE_CANCELEVENTAMENITY_FAILURE = 'CORE_CANCELEVENTAMENITY_FAILURE';

var CORE_CANCELEVENTFOOD_REQUEST = 'CORE_CANCELEVENTFOOD_REQUEST';
var CORE_CANCELEVENTFOOD_SUCCESS = 'CORE_CANCELEVENTFOOD_SUCCESS';
var CORE_CANCELEVENTFOOD_FAILURE = 'CORE_CANCELEVENTFOOD_FAILURE';
var CORE_CREATE_ORDER_REQUEST = 'CORE_CREATE_ORDER_REQUEST';
var CORE_CREATE_ORDER_SUCCESS = 'CORE_CREATE_ORDER_SUCCESS';
var CORE_CREATE_ORDER_FAILURE = 'CORE_CREATE_ORDER_FAILURE';

var CORE_LOAD_ORDER_INFO_REQUEST = 'CORE_LOAD_ORDER_INFO_REQUEST';
var CORE_LOAD_ORDER_INFO_SUCCESS = 'CORE_LOAD_ORDER_INFO_SUCCESS';
var CORE_LOAD_ORDER_INFO_FAILURE = 'CORE_LOAD_ORDER_INFO_FAILURE';

var CORE_EDIT_ORDER_REQUEST = 'CORE_EDIT_ORDER_REQUEST';
var CORE_EDIT_ORDER_SUCCESS = 'CORE_EDIT_ORDER_SUCCESS';
var CORE_EDIT_ORDER_FAILURE = 'CORE_EDIT_ORDER_FAILURE';

var CORE_LOAD_LAST_USERS_REQUEST = 'CORE_LOAD_LAST_USERS_REQUEST';
var CORE_LOAD_LAST_USERS_SUCCESS = 'CORE_LOAD_LAST_USERS_SUCCESS';
var CORE_LOAD_LAST_USERS_FAILURE = 'CORE_LOAD_LAST_USERS_FAILURE';

var CORE_LOAD_EVENT_LOG_TITLE_REQUEST = 'CORE_LOAD_EVENT_LOG_TITLE_REQUEST';
var CORE_LOAD_EVENT_LOG_TITLE_SUCCESS = 'CORE_LOAD_EVENT_LOG_TITLE_SUCCESS';
var CORE_LOAD_EVENT_LOG_TITLE_FAILURE = 'CORE_LOAD_EVENT_LOG_TITLE_FAILURE';

var CORE_CREATE_EVENT_LOG_REQUEST = 'CORE_CREATE_EVENT_LOG_REQUEST';
var CORE_CREATE_EVENT_LOG_SUCCESS = 'CORE_CREATE_EVENT_LOG_SUCCESS';
var CORE_CREATE_EVENT_LOG_FAILURE = 'CORE_CREATE_EVENT_LOG_FAILURE';

var CORE_SCANQR_REQUEST = 'CORE_SCANQR_REQUEST';
var CORE_SCANQR_SUCCESS = 'CORE_SCANQR_SUCCESS';
var CORE_SCANQR_FAILURE = 'CORE_SCANQR_FAILURE';

var CORE_LOAD_ROOM_FORMAT_REQUEST = 'CORE_LOAD_ROOM_FORMAT_REQUEST';
var CORE_LOAD_ROOM_FORMAT_SUCCESS = 'CORE_LOAD_ROOM_FORMAT_SUCCESS';
var CORE_LOAD_ROOM_FORMAT_FAILURE = 'CORE_LOAD_ROOM_FORMAT_FAILURE';

var CORE_LOAD_EVENTSERVICEAMENITY_REQUEST = 'CORE_LOAD_EVENTSERVICEAMENITY_REQUEST';
var CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS = 'CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS';
var CORE_LOAD_EVENTSERVICEAMENITY_FAILURE = 'CORE_LOAD_EVENTSERVICEAMENITY_FAILURE';

var CORE_LOAD_EVENTSERVICEFBS_REQUEST = 'LOAD_EVENTSERVICEFBS_REQUEST';
var CORE_LOAD_EVENTSERVICEFBS_SUCCESS = 'LOAD_EVENTSERVICEFBS_SUCCESS';
var CORE_LOAD_EVENTSERVICEFBS_FAILURE = 'LOAD_EVENTSERVICEFBS_FAILURE';

var CORE_LOAD_ROOM_TYPE_REQUEST = 'CORE_LOAD_ROOM_TYPE_REQUEST';
var CORE_LOAD_ROOM_TYPE_SUCCESS = 'CORE_LOAD_ROOM_TYPE_SUCCESS';
var CORE_LOAD_ROOM_TYPE_FAILURE = 'CORE_LOAD_ROOM_TYPE_FAILURE';

var CORE_LOAD_EVENTINFOSERVICE_REQUEST = 'CORE_LOAD_EVENTINFOSERVICE_REQUEST';
var CORE_LOAD_EVENTINFOSERVICE_SUCCESS = 'CORE_LOAD_EVENTINFOSERVICE_SUCCESS';
var CORE_LOAD_EVENTINFOSERVICE_FAILURE = 'CORE_LOAD_EVENTINFOSERVICE_FAILURE';

var CORE_SAVE_FORMSUGGEST = 'CORE_SAVE_FORMSUGGEST';
var CORE_SAVE_FORMSEARCHNAME = 'CORE_SAVE_FORMSEARCHNAME';
var CORE_CLEAR_FORMSEARCHNAME = 'CORE_CLEAR_FORMSEARCHNAME';

var CORE_LOAD_SETTINGS_REQUEST = 'CORE_LOAD_SETTINGS_REQUEST';
var CORE_LOAD_SETTINGS_SUCCESS = 'CORE_LOAD_SETTINGS_SUCCESS';
var CORE_LOAD_SETTINGS_FAILURE = 'CORE_LOAD_SETTINGS_FAILURE';

var CORE_VERIFY_LOGIN_REQUEST = 'CORE_VERIFY_LOGIN_REQUEST';
var CORE_VERIFY_LOGIN_SUCCESS = 'CORE_VERIFY_LOGIN_SUCCESS';
var CORE_VERIFY_LOGIN_FAILURE = 'CORE_VERIFY_LOGIN_FAILURE';

var CORE_SEND_REPORT_REQUEST = 'CORE_SEND_REPORT_REQUEST';
var CORE_SEND_REPORT_SUCCESS = 'CORE_SEND_REPORT_SUCCESS';
var CORE_SEND_REPORT_FAILURE = 'CORE_SEND_REPORT_FAILURE';

var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST';
var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS';
var CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE';

var CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST';
var CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS';
var CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE';

var CORE_FIRST_CHANGE_PASSWORD_REQUEST = 'CORE_FIRST_CHANGE_PASSWORD_REQUEST';
var CORE_FIRST_CHANGE_PASSWORD_SUCCESS = 'CORE_FIRST_CHANGE_PASSWORD_SUCCESS';
var CORE_FIRST_CHANGE_PASSWORD_FAILURE = 'CORE_FIRST_CHANGE_PASSWORD_FAILURE';

var CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST';
var CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS';
var CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE';

var CORE_LOAD_LOCATION_USER_REQUEST = 'CORE_LOAD_LOCATION_USER_REQUEST';
var CORE_LOAD_LOCATION_USER_SUCCESS = 'CORE_LOAD_LOCATION_USER_SUCCESS';
var CORE_LOAD_LOCATION_USER_FAILURE = 'CORE_LOAD_LOCATION_USER_FAILURE';

var CORE_CHANGEROLE_FRONTEND_REQUEST = 'CORE_CHANGEROLE_FRONTEND_REQUEST';
var CORE_CHANGEROLE_FRONTEND_SUCCESS = 'CORE_CHANGEROLE_FRONTEND_SUCCESS';
var CORE_CHANGEROLE_FRONTEND_FAILURE = 'CORE_CHANGEROLE_FRONTEND_FAILURE';

var CORE_LOAD_ROLESETTINGS_REQUEST = 'CORE_LOAD_ROLESETTINGS_REQUEST';
var CORE_LOAD_ROLESETTINGS_SUCCESS = 'CORE_LOAD_ROLESETTINGS_SUCCESS';
var CORE_LOAD_ROLESETTINGS_FAILURE = 'CORE_LOAD_ROLESETTINGS_FAILURE';

var CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST';
var CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS';
var CORE_LOAD_ALL_EVENT_ROOM_SERVICE_FAILURE = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_FAILURE';

var CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST = 'CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST';
var CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS = 'CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS';
var CORE_CHANGEEMAILNOTI_FRONTEND_FAILURE = 'CORE_CHANGEEMAILNOTI_FRONTEND_FAILURE';

var CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST';
var CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS';
var CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_FAILURE = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_FAILURE';

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/front/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 500, 503];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });

        if (resStatusError.includes(res.status)) {
            res.json().then(function (json) {
                console.log(json);
                // return json.value
                return reject(_extends({ statusText: res.statusText }, json));
            });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();

            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(475);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/front/lib/index.js + 6 modules
var lib = __webpack_require__(157);

// CONCATENATED MODULE: ./src/front/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            var isCORE = entry.types[0].startsWith("CORE");

            if (isCORE) {
                var token = Object(lib["j" /* getAccessToken */])();

                if (!token) return next(action);

                var _getAllToken = Object(lib["k" /* getAllToken */])(),
                    expires_on = _getAllToken.expires_on,
                    access_token = _getAllToken.access_token;

                var currentTime = moment_timezone_default()().format(lib["i" /* dateTimeFormat */]);
                var duration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(expires_on).diff(currentTime));
                var minutes = duration.asMinutes();

                if (minutes < 10) {
                    console.log('request new token');
                    fetch(lib["a" /* CORE_API_ENDPOINT */] + '/user/refeshtoken', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ access_token: access_token })
                    }).then(function (res) {
                        return res.json();
                    }).then(function (json) {
                        return Object(lib["s" /* setToken */])(json);
                    }).then(function () {
                        return next(action);
                    });
                } else {
                    next(action);
                }
            } else {
                next(action);
            }
        };
    };
});
// CONCATENATED MODULE: ./src/front/middlewares/setToken.js
var setToken__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



// import types from '../types'
/* harmony default export */ var setToken = (function (store) {
	return function (next) {
		return function (action) {

			var entry = action[CALL_API];
			// const ignorTypes  = [types.]
			if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

			var token = void 0;
			var entryType = entry.types[0];

			if (entryType.startsWith("CORE")) {
				token = Object(lib["j" /* getAccessToken */])();
			}
			// else if(entry.types[0].startsWith("O365")){ 
			//   token = getAccessToken()
			// }

			if (!token) return next(action);

			entry.headers = setToken__extends({}, entry.headers);
			if (token) {
				entry.headers.Authorization = 'Bearer ' + token;
			}

			next(action);
		};
	};
});
// CONCATENATED MODULE: ./src/front/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Loading = function Loading() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'Loading...'
    );
};

/* harmony default export */ __webpack_exports__["a"] = (function (opts) {
    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()(_extends({
        loading: Loading
    }, opts));
});

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUsers */
/* harmony export (immutable) */ __webpack_exports__["e"] = getUserInfo;
/* unused harmony export getAuthState */
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["a"] = getChangeSendMailResetPassword;
/* unused harmony export getHasSendReport */
/* harmony export (immutable) */ __webpack_exports__["d"] = getSendEmail;
/* harmony export (immutable) */ __webpack_exports__["c"] = getLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Lib__ = __webpack_require__(157);


function getUsers(state, props) {
    return state.users;
}

function getUserInfo(state, props) {
    return state.userInfo;
}

function getAuthState(state, props) {
    return state.auth;
}

function getIsLoggedIn(state) {
    var _getAllToken = Object(__WEBPACK_IMPORTED_MODULE_0_Lib__["k" /* getAllToken */])(),
        access_token = _getAllToken.access_token;

    return !!access_token;
}

function getChangeSendMailResetPassword(state) {
    return state.sendMailResetPassword;
}

function getHasSendReport(state) {
    return state.hasSendReport;
}

function getSendEmail(state) {
    return state.sendMail;
}

function getLocation(state) {
    return state.location;
}

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(480);


/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__);





var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(492);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(104);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(23);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/src/index.js
var src = __webpack_require__(502);
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/front/store/schema.js


var eventSchema = new src["schema"].Entity('events');
// EXTERNAL MODULE: ./src/front/store/configureStore.js
var configureStore = __webpack_require__(508);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/front/store/index.js


// EXTERNAL MODULE: ./src/front/features/ui/components/Loadable.js
var Loadable = __webpack_require__(474);

// CONCATENATED MODULE: ./src/front/features/ui/components/Routes.js




var AsyncNotFound = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1055));
    }
});

var AsyncLogin = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1056));
    }
});

//New
var AsyncSearchRoomBasic = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1057));
    }
});

var AsyncSearchRoomAdvance = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1058));
    }
});

var AsyncRoomSlots = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1059));
    }
});

var AsyncCreateEvent = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1060));
    }
});

var AsyncCreateEventTrainingNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1061));
    }
});

var AsyncCreateEventSuccessNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1062));
    }
});

var AsyncEventStatus = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1063));
    }
});

var AsyncEditEventNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1064));
    }
});

var AsyncEditEventTrainingNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1065));
    }
});

var AsyncEditEventSuccessNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1066));
    }
});

var AsyncEventDetail = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1067));
    }
});

var AsyncMyMeetingComing = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1068));
    }
});

var AsyncMyMeetingHistory = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1069));
    }
});

var AsyncMyMeetingCalendar = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1070));
    }
});

var AsyncScanQrcodeCheckin = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1071));
    }
});

var AsyncScanQrcodeRoom = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1072));
    }
});

var AsyncUserInformation = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1073));
    }
});

var AsyncTermAndConditionNew = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1074));
    }
});

var AsyncFirstChangePassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1075));
    }
});

var AsyncLocation = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1076));
    }
});

var AsyncChangePassword = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1077));
    }
});

var AsyncRoomService = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1078));
    }
});

var x = Object(Loadable["a" /* default */])({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1079));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        es["e" /* Switch */],
        null,
        react_default.a.createElement(es["d" /* Route */], { path: '/login', component: AsyncLogin }),
        react_default.a.createElement(es["d" /* Route */], { path: '/viewterm', component: AsyncTermAndConditionNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/term', component: AsyncTermAndConditionNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/userinfo', component: AsyncUserInformation }),
        react_default.a.createElement(es["d" /* Route */], { path: '/search/:text', component: AsyncSearchRoomBasic }),
        react_default.a.createElement(es["d" /* Route */], { path: '/home', component: AsyncSearchRoomBasic }),
        react_default.a.createElement(es["d" /* Route */], { path: '/searchAdvance/', component: AsyncSearchRoomAdvance }),
        react_default.a.createElement(es["d" /* Route */], { path: '/roomSlots/:path/:id/:date/:start/:end', component: AsyncRoomSlots }),
        react_default.a.createElement(es["d" /* Route */], { path: '/roomSlots/:path/:id', component: AsyncRoomSlots }),
        react_default.a.createElement(es["d" /* Route */], { path: '/myreservationHistory', component: AsyncMyMeetingHistory }),
        react_default.a.createElement(es["d" /* Route */], { path: '/myreservationComing', component: AsyncMyMeetingComing }),
        react_default.a.createElement(es["d" /* Route */], { path: '/myreservationDay', component: AsyncMyMeetingCalendar }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createEvent/:path/:id/:single/:startDate/:endDate/:startTime/:endTime', component: AsyncCreateEvent }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createEvent/:path/:id', component: AsyncCreateEvent }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createEventTraining/:path/:id/:single/:startDate/:endDate/:startTime/:endTime', component: AsyncCreateEventTrainingNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createEventTraining/:path/:id', component: AsyncCreateEventTrainingNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/createEventSuccess/:eventid', component: AsyncCreateEventSuccessNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/editEvent/:type/:id', component: AsyncEditEventNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/editEventTraining/:type/:id', component: AsyncEditEventTrainingNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/editEventSuccess/:eventid', component: AsyncEditEventSuccessNew }),
        react_default.a.createElement(es["d" /* Route */], { path: '/eventDetail/:eventid', component: AsyncEventDetail }),
        react_default.a.createElement(es["d" /* Route */], { path: '/checkinConfirm/:id', component: AsyncEventStatus }),
        react_default.a.createElement(es["d" /* Route */], { path: '/checkIn/:roomid/:eventid', component: AsyncScanQrcodeCheckin }),
        react_default.a.createElement(es["d" /* Route */], { path: '/qrcode', component: AsyncScanQrcodeRoom }),
        react_default.a.createElement(es["d" /* Route */], { path: '/userlocation', component: AsyncLocation }),
        react_default.a.createElement(es["d" /* Route */], { path: '/x', component: x }),
        react_default.a.createElement(es["d" /* Route */], { path: '/reset/:email', component: AsyncChangePassword }),
        react_default.a.createElement(es["d" /* Route */], { path: '/changepassword/:id', component: AsyncFirstChangePassword }),
        react_default.a.createElement(es["d" /* Route */], { path: '/roomservices', component: AsyncRoomService }),
        react_default.a.createElement(es["d" /* Route */], { path: '/', component: AsyncSearchRoomBasic }),
        react_default.a.createElement(es["d" /* Route */], { component: AsyncNotFound })
    );
});
// CONCATENATED MODULE: ./src/front/features/ui/components/App.js


// import { Container} from 'semantic-ui-react'

/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(Routes, null)
    );
});
// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(80);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(218);

// EXTERNAL MODULE: ./src/front/features/ui/selectors.js
var selectors = __webpack_require__(219);

// EXTERNAL MODULE: ./src/front/types.js
var types = __webpack_require__(24);

// CONCATENATED MODULE: ./src/front/error.js

// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

var error_errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf"
};

/* harmony default export */ var front_error = ({
	errorMessage: error_errorMessage
});
// CONCATENATED MODULE: ./src/front/features/ui/actions.js





function setError(hasError) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var defaultError = {
        code: "00010000",
        message: front_error["00010000"]
    };

    if (typeof error === 'string' && error in front_error) {
        defaultError = {
            code: error,
            message: front_error[error]
        };
    } else if (error === null || hasError === false) {
        defaultError = null;
    } else if (error.code !== undefined && error.message !== undefined) {
        defaultError = error;
    }

    return {
        type: types["_120" /* SET_ERROR */],
        hasError: hasError,
        error: defaultError
    };
}
// CONCATENATED MODULE: ./src/front/features/ui/components/ErrorMessageDialog.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ErrorMessageDialog_ErrorMessageDialog = function (_React$Component) {
    _inherits(ErrorMessageDialog, _React$Component);

    function ErrorMessageDialog() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ErrorMessageDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessageDialog.__proto__ || Object.getPrototypeOf(ErrorMessageDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.close = function () {
            _this.setState({ open: false });
            _this.props.clearError();
        }, _this.mapErrorUnprocessableEntity = function (errors) {
            // console.log('5555', Object.keys(errors))
            var text = [],
                keys = Object.keys(errors);
            keys.forEach(function (key) {
                var _errors$key = errors[key],
                    msg = _errors$key.msg,
                    param = _errors$key.param;

                text.push(react_default.a.createElement(
                    'p',
                    { className: 'user-font-weight500 user-no-margin' },
                    msg,
                    ' - ',
                    param
                ));
            });
            return text;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ErrorMessageDialog, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProp) {
            this.setState({ open: nextProp.hasError });
        }
    }, {
        key: 'render',
        value: function render() {
            // const { hasError, error } = this.props
            var _props$uiError = this.props.uiError,
                errorCode = _props$uiError.errorCode,
                errorMessage = _props$uiError.errorMessage;

            return react_default.a.createElement(
                dist_es["p" /* Modal */],
                { open: this.state.open, onClose: this.close },
                react_default.a.createElement(
                    dist_es["p" /* Modal */].Header,
                    null,
                    react_default.a.createElement(
                        'h3',
                        { className: 'user-font-weight700' },
                        'System Message'
                    )
                ),
                react_default.a.createElement(
                    dist_es["p" /* Modal */].Content,
                    null,
                    react_default.a.createElement(
                        dist_es["p" /* Modal */].Description,
                        null,
                        react_default.a.createElement(
                            'p',
                            null,
                            'Error Code : ',
                            errorCode
                        ),
                        react_default.a.createElement(
                            'p',
                            null,
                            'Error Message : ',
                            errorMessage
                        )
                    )
                ),
                react_default.a.createElement(
                    dist_es["p" /* Modal */].Actions,
                    null,
                    react_default.a.createElement(
                        dist_es["a" /* Button */],
                        {
                            className: 'buttonSubmit',
                            onClick: this.close },
                        'Ok'
                    )
                )
            );
        }
    }]);

    return ErrorMessageDialog;
}(react_default.a.Component);

/* harmony default export */ var components_ErrorMessageDialog = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state, props) {
    return {
        hasError: Object(selectors["b" /* getHasError */])(state),
        error: Object(selectors["a" /* getError */])(state),
        uiError: Object(selectors["d" /* getUiMessage */])(state)
    };
}, function (dispatch) {
    return {
        clearError: function clearError() {
            dispatch(setError(false));
        }
    };
}))(ErrorMessageDialog_ErrorMessageDialog));
// CONCATENATED MODULE: ./src/front/features/ui/components/LoadingDialog.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var LoadingDialog_LoadingDialog = function LoadingDialog(props) {
	return props.isLoading ? react_default.a.createElement(
		dist_es["d" /* Dimmer */],
		{ active: true },
		react_default.a.createElement(
			dist_es["n" /* Loader */],
			{ size: 'large' },
			'Loading'
		)
	) : "";
};

/* harmony default export */ var components_LoadingDialog = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state) {
	return {
		isLoading: Object(selectors["c" /* getIsLoading */])(state)
	};
}), Object(Recompose["f" /* withProps */])(function (props) {
	return _extends({}, props);
}))(LoadingDialog_LoadingDialog));
// CONCATENATED MODULE: ./src/front/features/ui/components/Root.prod.js





// import { Container } from 'semantic-ui-react'
// import Header from 'Features/ui/components/Header'
// import AuthFooter from 'Features/ui/components/AuthFooter'



var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
    return react_default.a.createElement(
        react_redux_es["Provider"],
        { store: store },
        react_default.a.createElement(
            es["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(App, null),
                react_default.a.createElement(components_ErrorMessageDialog, null),
                react_default.a.createElement(components_LoadingDialog, null)
            )
        )
    );
});

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(509);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(83);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var lib = __webpack_require__(510);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/front/middlewares/index.js + 3 modules
var front_middlewares = __webpack_require__(473);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 225 modules
var redux_form_es = __webpack_require__(477);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var reapop_lib = __webpack_require__(630);
var reapop_lib_default = /*#__PURE__*/__webpack_require__.n(reapop_lib);

// EXTERNAL MODULE: ./src/front/types.js
var types = __webpack_require__(24);

// CONCATENATED MODULE: ./src/front/features/ui/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var reducer_initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
};

/* harmony default export */ var reducer = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case types["_54" /* CORE_LOAD_ORDERS_REQUEST */]:
        case types["_83" /* CORE_LOAD_SLOTS_REQUEST */]:
        case types["_62" /* CORE_LOAD_ROOMINFO_REQUEST */]:
        case types["_18" /* CORE_LOAD_EVENTINCOMING_REQUEST */]:
        case types["_117" /* LOAD_ROOMINFO_REQUEST */]:
        case types["_15" /* CORE_LOAD_EVENTHISTORY_REQUEST */]:
        case types["_33" /* CORE_LOAD_FLOORS_REQUEST */]:
        case types["B" /* CORE_CREATE_EVENT_REQUEST */]:
        case types["_3" /* CORE_LOAD_AMENITIES_REQUEST */]:
        case types["b" /* BSRS_LOGIN_REQUEST */]:
        case types["_23" /* CORE_LOAD_EVENTINFO_REQUEST */]:
        case types["O" /* CORE_EDIT_EVENT_REQUEST */]:
        case types["H" /* CORE_DELETE_EVENT_REQUEST */]:
        case types["u" /* CORE_CHECKIN_REQUEST */]:
        case types["_36" /* CORE_LOAD_FLOOR_INFO_REQUEST */]:
        case types["_12" /* CORE_LOAD_EVENTCALENDAR_REQUEST */]:
        case types["_98" /* CORE_SEARCH_ROOMS_REQUEST */]:
        case types["_71" /* CORE_LOAD_ROOMS_SUGGEST_REQUEST */]:
        case types["_111" /* CORE_VERIFY_BYPASS_REQUEST */]:
        case types["_74" /* CORE_LOAD_ROOM_FORMAT_REQUEST */]:
        case types["_80" /* CORE_LOAD_SETTINGS_REQUEST */]:
        case types["_105" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST */]:
        case types["r" /* CORE_CHANGE_PASSWORD_REQUEST */]:
        case types["R" /* CORE_FIRST_CHANGE_PASSWORD_REQUEST */]:
        case types["_108" /* CORE_SEND_REPORT_REQUEST */]:
        case types["_114" /* CORE_VERIFY_LOGIN_REQUEST */]:
        case types["U" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST */]:
        case types["o" /* CORE_CHANGEROLE_FRONTEND_REQUEST */]:
        // case CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST:
        case types["l" /* CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST */]:
        case types["X" /* CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST */]:
            return _extends({}, state, {
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["_55" /* CORE_LOAD_ORDERS_SUCCESS */]:
        case types["_84" /* CORE_LOAD_SLOTS_SUCCESS */]:
        case types["_63" /* CORE_LOAD_ROOMINFO_SUCCESS */]:
        case types["_118" /* LOAD_ROOMINFO_SUCCESS */]:
        case types["_19" /* CORE_LOAD_EVENTINCOMING_SUCCESS */]:
        case types["_16" /* CORE_LOAD_EVENTHISTORY_SUCCESS */]:
        case types["_34" /* CORE_LOAD_FLOORS_SUCCESS */]:
        case types["C" /* CORE_CREATE_EVENT_SUCCESS */]:
        case types["_4" /* CORE_LOAD_AMENITIES_SUCCESS */]:
        case types["c" /* BSRS_LOGIN_SUCCESS */]:
        case types["_24" /* CORE_LOAD_EVENTINFO_SUCCESS */]:
        case types["P" /* CORE_EDIT_EVENT_SUCCESS */]:
        case types["I" /* CORE_DELETE_EVENT_SUCCESS */]:
        case types["v" /* CORE_CHECKIN_SUCCESS */]:
        case types["_37" /* CORE_LOAD_FLOOR_INFO_SUCCESS */]:
        case types["_13" /* CORE_LOAD_EVENTCALENDAR_SUCCESS */]:
        case types["_99" /* CORE_SEARCH_ROOMS_SUCCESS */]:
        case types["_72" /* CORE_LOAD_ROOMS_SUGGEST_SUCCESS */]:
        case types["_112" /* CORE_VERIFY_BYPASS_SUCCESS */]:
        case types["_75" /* CORE_LOAD_ROOM_FORMAT_SUCCESS */]:
        case types["_81" /* CORE_LOAD_SETTINGS_SUCCESS */]:
        case types["_106" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS */]:
        case types["s" /* CORE_CHANGE_PASSWORD_SUCCESS */]:
        case types["S" /* CORE_FIRST_CHANGE_PASSWORD_SUCCESS */]:
        case types["_109" /* CORE_SEND_REPORT_SUCCESS */]:
        case types["_115" /* CORE_VERIFY_LOGIN_SUCCESS */]:
        case types["V" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS */]:
        case types["p" /* CORE_CHANGEROLE_FRONTEND_SUCCESS */]:
        // case CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS:
        case types["m" /* CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS */]:
        case types["Y" /* CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS */]:
            return _extends({}, state, {
                isLoading: false,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            });
        case types["_53" /* CORE_LOAD_ORDERS_FAILURE */]:
        case types["_32" /* CORE_LOAD_FLOORS_FAILURE */]:
        case types["_61" /* CORE_LOAD_ROOMINFO_FAILURE */]:
        case types["_116" /* LOAD_ROOMINFO_FAILURE */]:
        case types["_82" /* CORE_LOAD_SLOTS_FAILURE */]:
        case types["_17" /* CORE_LOAD_EVENTINCOMING_FAILURE */]:
        case types["_14" /* CORE_LOAD_EVENTHISTORY_FAILURE */]:
        case types["x" /* CORE_CREATE_EVENT_FAILURE */]:
        case types["_2" /* CORE_LOAD_AMENITIES_FAILURE */]:
        case types["a" /* BSRS_LOGIN_FAILURE */]:
        case types["_22" /* CORE_LOAD_EVENTINFO_FAILURE */]:
        case types["N" /* CORE_EDIT_EVENT_FAILURE */]:
        case types["D" /* CORE_DELETE_EVENT_FAILURE */]:
        case types["t" /* CORE_CHECKIN_FAILURE */]:
        case types["_35" /* CORE_LOAD_FLOOR_INFO_FAILURE */]:
        case types["_11" /* CORE_LOAD_EVENTCALENDAR_FAILURE */]:
        case types["_97" /* CORE_SEARCH_ROOMS_FAILURE */]:
        case types["_70" /* CORE_LOAD_ROOMS_SUGGEST_FAILURE */]:
        case types["_110" /* CORE_VERIFY_BYPASS_FAILURE */]:
        case types["_73" /* CORE_LOAD_ROOM_FORMAT_FAILURE */]:
        case types["_79" /* CORE_LOAD_SETTINGS_FAILURE */]:
        case types["_104" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE */]:
        case types["q" /* CORE_CHANGE_PASSWORD_FAILURE */]:
        case types["Q" /* CORE_FIRST_CHANGE_PASSWORD_FAILURE */]:
        case types["_107" /* CORE_SEND_REPORT_FAILURE */]:
        case types["_113" /* CORE_VERIFY_LOGIN_FAILURE */]:
        case types["T" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE */]:
        case types["n" /* CORE_CHANGEROLE_FRONTEND_FAILURE */]:
        // case CORE_LOAD_ALL_EVENT_ROOM_SERVICE_FAILURE:
        case types["k" /* CORE_CHANGEEMAILNOTI_FRONTEND_FAILURE */]:
        case types["W" /* CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_FAILURE */]:
            var _action$payload = action.payload,
                statusText = _action$payload.statusText,
                code = _action$payload.code,
                message = _action$payload.message;

            var returnData = _extends({}, state, {
                isLoading: false,
                hasError: true,
                statusText: statusText,
                errorCode: code,
                errorMessage: message
            });
            return returnData;

        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/front/features/rooms/reducer.js


var rooms_reducer_initialState = [];
/* harmony default export */ var rooms_reducer = ({
  rooms: function rooms() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_98" /* CORE_SEARCH_ROOMS_REQUEST */]:
      case types["_68" /* CORE_LOAD_ROOMS_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_99" /* CORE_SEARCH_ROOMS_SUCCESS */]:
      case types["_69" /* CORE_LOAD_ROOMS_SUCCESS */]:
        if (action.payload[0]) {
          return action.payload[0];
        } else return [];
      case types["_91" /* CORE_ROOMS_CLEAR */]:
        return [];
      default:
        return state;
    }
  },
  roomssuggest: function roomssuggest() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_71" /* CORE_LOAD_ROOMS_SUGGEST_REQUEST */]:
        return {};
      case types["_72" /* CORE_LOAD_ROOMS_SUGGEST_SUCCESS */]:
        if (action.payload) {
          var payload = action.payload;
          return payload;
        } else return {};

      default:
        return state;
    }
  },
  roomsfirstsuggest: function roomsfirstsuggest() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_66" /* CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST */]:
        return {};
      case types["_67" /* CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS */]:
        if (action.payload) {
          var payload = action.payload;
          return payload;
        } else return {};

      default:
        return state;
    }
  },
  roomInfo: function roomInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_62" /* CORE_LOAD_ROOMINFO_REQUEST */]:
      case types["_117" /* LOAD_ROOMINFO_REQUEST */]:
        return {};
      case types["_63" /* CORE_LOAD_ROOMINFO_SUCCESS */]:
      case types["_118" /* LOAD_ROOMINFO_SUCCESS */]:
        if (action.payload) {
          return action.payload;
        } else return {};
      default:
        return state;
    }
  },
  slots: function slots() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_83" /* CORE_LOAD_SLOTS_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_84" /* CORE_LOAD_SLOTS_SUCCESS */]:
        if (action.payload[0]) {
          return action.payload;
        } else return [{}];

      default:
        return state;
    }
  },
  roomFormat: function roomFormat() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_74" /* CORE_LOAD_ROOM_FORMAT_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_75" /* CORE_LOAD_ROOM_FORMAT_SUCCESS */]:
        if (action.payload) {
          return action.payload;
        } else return [];
      default:
        return state;
    }
  },
  roomType: function roomType() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_77" /* CORE_LOAD_ROOM_TYPE_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_78" /* CORE_LOAD_ROOM_TYPE_SUCCESS */]:
        if (action.payload) {
          return action.payload;
        } else return [];
      default:
        return state;
    }
  },
  formSuggest: function formSuggest() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_93" /* CORE_SAVE_FORMSUGGEST */]:
        return action.form;
      default:
        return state;
    }
  },
  formSearchName: function formSearchName() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_92" /* CORE_SAVE_FORMSEARCHNAME */]:
        return action.form;
      case types["w" /* CORE_CLEAR_FORMSEARCHNAME */]:
        return {};
      default:
        return state;
    }
  },
  settings: function settings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_80" /* CORE_LOAD_SETTINGS_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_81" /* CORE_LOAD_SETTINGS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  roleSetting: function roleSetting() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_59" /* CORE_LOAD_ROLESETTINGS_REQUEST */]:
        return rooms_reducer_initialState;
      case types["_60" /* CORE_LOAD_ROLESETTINGS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/floors/reducer.js


var floors_reducer_initialState = [];
/* harmony default export */ var floors_reducer = ({
  floors: function floors() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floors_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_33" /* CORE_LOAD_FLOORS_REQUEST */]:
        return floors_reducer_initialState;

      case types["_34" /* CORE_LOAD_FLOORS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var floors = [];
          for (var i = 0; i < payload.length; i++) {
            floors.push({
              name: payload[i].name,
              buildingName: payload[i].buildingName,
              _id: payload[i]._id
            });
          }
          return floors;
        } else return [{}];

      default:
        return state;
    }
  },
  floorInfo: function floorInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floors_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_36" /* CORE_LOAD_FLOOR_INFO_REQUEST */]:
        return floors_reducer_initialState;

      case types["_37" /* CORE_LOAD_FLOOR_INFO_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var floorInfo = [];
          floorInfo.push({
            _id: payload._id,
            name: payload.name,
            buildingName: payload.buildingName
          });
          return floorInfo;
        } else return [{}];

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/amenity/reducer.js


var amenity_reducer_initialState = [];
/* harmony default export */ var amenity_reducer = ({
  amenities: function amenities() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_3" /* CORE_LOAD_AMENITIES_REQUEST */]:
        return amenity_reducer_initialState;
      case types["_4" /* CORE_LOAD_AMENITIES_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var amenities = [];
          for (var i = 0; i < payload.length; i++) {
            amenities.push({
              name: payload[i].name,
              _id: payload[i]._id
            });
          }
          return amenities;
        } else return [{}];

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/user/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var user_reducer_initialState = [];
/* harmony default export */ var user_reducer = ({
  lastusers: function lastusers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_48" /* CORE_LOAD_LAST_USERS_REQUEST */]:
        return user_reducer_initialState;
      case types["_49" /* CORE_LOAD_LAST_USERS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var lastuser = [];
          for (var i = 0; i < payload.length; i++) {
            lastuser.push({ value: payload[i]._id, key: i, text: payload[i].fullName });
          }
          return lastuser;
        } else return [];

      default:
        return state;
    }
  },
  userInfo: function userInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_89" /* CORE_LOAD_USER_INFO_REQUEST */]:
      case types["_111" /* CORE_VERIFY_BYPASS_REQUEST */]:
      case types["_114" /* CORE_VERIFY_LOGIN_REQUEST */]:
      case types["l" /* CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST */]:
      case types["m" /* CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS */]:
        return state;
      case types["_115" /* CORE_VERIFY_LOGIN_SUCCESS */]:
      case types["_90" /* CORE_LOAD_USER_INFO_SUCCESS */]:
      case types["_112" /* CORE_VERIFY_BYPASS_SUCCESS */]:
      case types["_113" /* CORE_VERIFY_LOGIN_FAILURE */]:
        return action.payload;
      default:
        return {};
    }
  },
  auth: function auth() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["e" /* CORE_ACCEPT_TERM_REQUEST */]:
        return {};
      case types["f" /* CORE_ACCEPT_TERM_SUCCESS */]:
        return reducer__extends({}, state);
      default:
        return {};
    }
  },
  sendMailResetPassword: function sendMailResetPassword() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_105" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST */]:
        return {};
      case types["_106" /* CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS */]:
        return {
          status: action.payload
        };
      default:
        return {};
    }
  },
  hasSendReport: function hasSendReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_108" /* CORE_SEND_REPORT_REQUEST */]:
        return [];
      case types["_109" /* CORE_SEND_REPORT_SUCCESS */]:
        return action.payload;
      default:
        return [];
    }
  },
  sendMail: function sendMail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["U" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST */]:
        return {};
      case types["V" /* CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS */]:
        if (typeof action.payload !== "undefined") return {
          status: action.payload
        };else return {};
      default:
        return state;
    }
  },
  location: function location() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_51" /* CORE_LOAD_LOCATION_USER_REQUEST */]:
        return state;
      case types["_52" /* CORE_LOAD_LOCATION_USER_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/users/reducer.js


var users_reducer_initialState = [];
/* harmony default export */ var users_reducer = ({
  users: function users() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : users_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_86" /* CORE_LOAD_USERS_REQUEST */]:
        return users_reducer_initialState;
      case types["_87" /* CORE_LOAD_USERS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var user = [];
          for (var i = 0; i < payload.length; i++) {
            user.push({ value: payload[i]._id, key: i, text: payload[i].fullName });
          }
          return user;
        } else return [{ value: 0, key: 0, text: 0 }];

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/events/reducer.js


var events_reducer_initialState = [];
/* harmony default export */ var events_reducer = ({
  events: function events() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : events_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      // case CORE_CREATE_EVENT_REQUEST:
      // case CORE_DELETE_EVENT_REQUEST:
      // case CORE_DELETE_EVENT_SUCCESS:
      //   return initialState
      // case CORE_CREATE_EVENT_SUCCESS:
      //   return action.payload
      case types["_23" /* CORE_LOAD_EVENTINFO_REQUEST */]:
        return {};
      case types["_24" /* CORE_LOAD_EVENTINFO_SUCCESS */]:
        if (action.payload[0]) {
          var payLoad = action.payload[0];
          return payLoad;
        } else return {};
      // case CORE_EDIT_EVENT_REQUEST:
      //   return {}
      // case CORE_EDIT_EVENT_SUCCESS:
      //   return action.payload
      default:
        return state;
    }
  },
  logTitle: function logTitle() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : events_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_30" /* CORE_LOAD_EVENT_LOG_TITLE_REQUEST */]:
        return events_reducer_initialState;
      case types["_31" /* CORE_LOAD_EVENT_LOG_TITLE_SUCCESS */]:
        if (action.payload[0]) {
          var payLoad = action.payload[0];
          return payLoad;
        } else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/mybookings/reducer.js


var mybookings_reducer_initialState = [];
/* harmony default export */ var mybookings_reducer = ({
  eventIncoming: function eventIncoming() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mybookings_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_18" /* CORE_LOAD_EVENTINCOMING_REQUEST */]:
        return mybookings_reducer_initialState;
      case types["_19" /* CORE_LOAD_EVENTINCOMING_SUCCESS */]:
        if (typeof action.payload[0] !== "undefined") return action.payload[0];else return [{}];

      default:
        return state;
    }
  },
  eventHistory: function eventHistory() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mybookings_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_15" /* CORE_LOAD_EVENTHISTORY_REQUEST */]:
        return mybookings_reducer_initialState;
      case types["_16" /* CORE_LOAD_EVENTHISTORY_SUCCESS */]:
        if (typeof action.payload[0] !== "undefined") return action.payload[0];else return [{}];
      default:
        return state;
    }
  },
  eventCalendar: function eventCalendar() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mybookings_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_12" /* CORE_LOAD_EVENTCALENDAR_REQUEST */]:
        return mybookings_reducer_initialState;
      case types["_13" /* CORE_LOAD_EVENTCALENDAR_SUCCESS */]:
        if (typeof action.payload[0] !== "undefined") return action.payload[0];else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/amenityandservice/reducer.js


var amenityandservice_reducer_initialState = [];
/* harmony default export */ var amenityandservice_reducer = ({
  amenityActive: function amenityActive() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_5" /* CORE_LOAD_AMENITYACTIVE_REQUEST */]:
      case types["_100" /* CORE_SENDAMENITY_REQUEST */]:
      case types["J" /* CORE_DONEAMENITY_REQUEST */]:
      case types["g" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return state;
      case types["_6" /* CORE_LOAD_AMENITYACTIVE_SUCCESS */]:
      case types["_101" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["K" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  amenityPast: function amenityPast() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_9" /* CORE_LOAD_AMENITYPAST_REQUEST */]:
      case types["_100" /* CORE_SENDAMENITY_REQUEST */]:
      case types["J" /* CORE_DONEAMENITY_REQUEST */]:
      case types["g" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return state;
      case types["_10" /* CORE_LOAD_AMENITYPAST_SUCCESS */]:
      case types["_101" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["K" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  amenityNext: function amenityNext() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_7" /* CORE_LOAD_AMENITYNEXT_REQUEST */]:
      case types["_100" /* CORE_SENDAMENITY_REQUEST */]:
      case types["J" /* CORE_DONEAMENITY_REQUEST */]:
      case types["g" /* CORE_CANCELEVENTAMENITY_REQUEST */]:
        return {};
      case types["_8" /* CORE_LOAD_AMENITYNEXT_SUCCESS */]:
      case types["_101" /* CORE_SENDAMENITY_SUCCESS */]:
      case types["h" /* CORE_CANCELEVENTAMENITY_SUCCESS */]:
      case types["K" /* CORE_DONEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodActive: function foodActive() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_38" /* CORE_LOAD_FOODACTIVE_REQUEST */]:
      case types["_102" /* CORE_SENDFOOD_REQUEST */]:
      case types["L" /* CORE_DONEFOOD_REQUEST */]:
      case types["i" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return state;
      case types["_39" /* CORE_LOAD_FOODACTIVE_SUCCESS */]:
      case types["_103" /* CORE_SENDFOOD_SUCCESS */]:
      case types["M" /* CORE_DONEFOOD_SUCCESS */]:
      case types["j" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodPast: function foodPast() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_42" /* CORE_LOAD_FOODPAST_REQUEST */]:
      case types["_102" /* CORE_SENDFOOD_REQUEST */]:
      case types["L" /* CORE_DONEFOOD_REQUEST */]:
      case types["i" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return state;
      case types["_43" /* CORE_LOAD_FOODPAST_SUCCESS */]:
      case types["_103" /* CORE_SENDFOOD_SUCCESS */]:
      case types["M" /* CORE_DONEFOOD_SUCCESS */]:
      case types["j" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  foodNext: function foodNext() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenityandservice_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_40" /* CORE_LOAD_FOODNEXT_REQUEST */]:
      case types["_102" /* CORE_SENDFOOD_REQUEST */]:
      case types["L" /* CORE_DONEFOOD_REQUEST */]:
      case types["i" /* CORE_CANCELEVENTFOOD_REQUEST */]:
        return {};
      case types["_41" /* CORE_LOAD_FOODNEXT_SUCCESS */]:
      case types["_103" /* CORE_SENDFOOD_SUCCESS */]:
      case types["M" /* CORE_DONEFOOD_SUCCESS */]:
      case types["j" /* CORE_CANCELEVENTFOOD_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderInfoService: function orderInfoService() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_20" /* CORE_LOAD_EVENTINFOSERVICE_REQUEST */]:
        return {};
      case types["_21" /* CORE_LOAD_EVENTINFOSERVICE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderAmenityList: function orderAmenityList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_25" /* CORE_LOAD_EVENTSERVICEAMENITY_REQUEST */]:
        return [];
      case types["_26" /* CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  orderFbsList: function orderFbsList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_27" /* CORE_LOAD_EVENTSERVICEFBS_REQUEST */]:
        return [];
      case types["_28" /* CORE_LOAD_EVENTSERVICEFBS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/orders/reducer.js
var orders_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var orders_reducer_initialState = [];

/* harmony default export */ var orders_reducer = ({
  orders: function orders() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : orders_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_54" /* CORE_LOAD_ORDERS_REQUEST */]:
        return orders_reducer_initialState;
      case types["_55" /* CORE_LOAD_ORDERS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var orders = [];
          for (var i = 1; i <= payload.length; i++) {
            orders.push(orders_reducer__extends({ no: i }, payload[i - 1]));
          }
          return orders;
        } else return [];

      default:
        return state;
    }
  },
  orderInfo: function orderInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_56" /* CORE_LOAD_ORDER_INFO_REQUEST */]:
        return {};
      case types["_57" /* CORE_LOAD_ORDER_INFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/foods/reducer.js


var foods_reducer_initialState = [];
/* harmony default export */ var foods_reducer = ({
  foods: function foods() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : foods_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_45" /* CORE_LOAD_FOODS_REQUEST */]:
        return foods_reducer_initialState;
      case types["_46" /* CORE_LOAD_FOODS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var amenities = [];
          for (var i = 0; i < payload.length; i++) {
            amenities.push({
              name: payload[i].name,
              _id: payload[i]._id
            });
          }
          return amenities;
        } else return [{}];

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/qrcode/reducer.js


var qrcode_reducer_initialState = [];
/* harmony default export */ var qrcode_reducer = ({
  users: function users() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : qrcode_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_86" /* CORE_LOAD_USERS_REQUEST */]:
        return qrcode_reducer_initialState;
      case types["_87" /* CORE_LOAD_USERS_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var user = [];
          for (var i = 0; i < payload.length; i++) {
            user.push({ value: payload[i]._id, key: i, text: payload[i].fullName });
          }
          return user;
        } else return [{ value: 0, key: 0, text: 0 }];

      default:
        return state;
    }
  },
  userInfo: function userInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : qrcode_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_89" /* CORE_LOAD_USER_INFO_REQUEST */]:
        return {};
      case types["_90" /* CORE_LOAD_USER_INFO_SUCCESS */]:
        return action.payload;
      default:
        return {};
    }
  },
  qrcode: function qrcode() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : qrcode_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_95" /* CORE_SCANQR_REQUEST */]:
        return {};
      case types["_96" /* CORE_SCANQR_SUCCESS */]:
        return action.payload;
      case types["_94" /* CORE_SCANQR_FAILURE */]:
        return action.payload;
      default:
        return {};
    }
  }
});
// CONCATENATED MODULE: ./src/front/features/roomService/reducer.js


/* harmony default export */ var roomService_reducer = ({
  eventService: function eventService() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["_0" /* CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST */]:
        return state;
      case types["_1" /* CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  eventMonthService: function eventMonthService() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case types["X" /* CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST */]:
        return state;
      case types["Y" /* CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/front/reducers.js



// import authReducer from 'Features/user/reducer'














/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["c" /* reducer */],
    notifications: Object(reapop_lib["reducer"])(),
    auth: user_reducer.auth,
    ui: reducer,
    rooms: rooms_reducer.rooms,
    roomssuggest: rooms_reducer.roomssuggest,
    roomsfirstsuggest: rooms_reducer.roomsfirstsuggest,
    slots: rooms_reducer.slots,
    floors: floors_reducer.floors,
    roomType: rooms_reducer.roomType,
    roomFormat: rooms_reducer.roomFormat,
    roomInfo: rooms_reducer.roomInfo,
    formSuggest: rooms_reducer.formSuggest,
    formSearchName: rooms_reducer.formSearchName,
    settings: rooms_reducer.settings,
    roleSetting: rooms_reducer.roleSetting,
    floorInfo: floors_reducer.floorInfo,
    amenities: amenity_reducer.amenities,
    users: users_reducer.users,
    hasSendReport: user_reducer.hasSendReport,
    lastusers: user_reducer.lastusers,
    userInfo: user_reducer.userInfo,
    eventinfo: events_reducer.events,
    logTitle: events_reducer.logTitle,
    eventIncoming: mybookings_reducer.eventIncoming,
    eventHistory: mybookings_reducer.eventHistory,
    eventCalendar: mybookings_reducer.eventCalendar,
    amenityActive: amenityandservice_reducer.amenityActive,
    amenityPast: amenityandservice_reducer.amenityPast,
    amenityNext: amenityandservice_reducer.amenityNext,
    foodActive: amenityandservice_reducer.foodActive,
    foodPast: amenityandservice_reducer.foodPast,
    foodNext: amenityandservice_reducer.foodNext,
    orders: orders_reducer.orders,
    orderInfo: orders_reducer.orderInfo,
    foods: foods_reducer.foods,
    qrcode: qrcode_reducer.qrcode,
    sendMailResetPassword: user_reducer.sendMailResetPassword,
    sendMail: user_reducer.sendMail,
    orderInfoService: amenityandservice_reducer.orderInfoService,
    orderAmenityList: amenityandservice_reducer.orderAmenityList,
    orderFbsList: amenityandservice_reducer.orderFbsList,
    location: user_reducer.location,
    eventService: roomService_reducer.eventService,
    eventMonthService: roomService_reducer.eventMonthService
}));
// CONCATENATED MODULE: ./src/front/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [front_middlewares["c" /* checkToken */], front_middlewares["d" /* setToken */], front_middlewares["b" /* api */], lib_default.a];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[479]);


// WEBPACK FOOTER //
// app.7feee2a41ddf387fd4a1.js